import React, { Fragment, useEffect, useState } from "react";
import stylesRequestData from "./RequestData.module.css";
import SearchSelectElement from "../../../shared/form/SearchSelectElement";
import { getDisputeDistricts } from "../../../adapters/apis/lookups/lookups";
import TextAreaElement from "../../../shared/form/TextAreaElement";
import InputElementDispute from "../../../shared/form/InputElementDispute";
import DatePickerFormated from "../../../shared/form/DatePickerFormated";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import {
  validateFileSizeDispute,
  validateFileTypeDispute,
  validateRequired,
} from "../../../helpers/Validation";
import { store_dispute_request } from "../../../adapters/apis/taxDispute/save";

const ValidateDisputeRequest = (setError, disputeRequestData) => {
  let valid = true;
  if (!validateRequired(disputeRequestData.submitter_request_character)) {
    valid = false;
    setError("submitter_request_character", "يجب اختيار صفة مقدم الطلب");
  } else {
    setError("submitter_request_character", "");
  }
  //valid user First Name
  if (!validateRequired(disputeRequestData.first_name)) {
    valid = false;
    setError("first_name", "يجب إدخال الاسم");
  } else {
    setError("first_name");
  }
  if (!validateRequired(disputeRequestData.rest_name)) {
    valid = false;
    setError("rest_name", "يجب إدخال الاسم");
  } else {
    setError("rest_name");
  }
  if (!validateRequired(disputeRequestData.correspondence_address)) {
    valid = false;
    setError("correspondence_address", "يجب إدخال العنوان");
  } else {
    setError("correspondence_address", "");
  }
  if (
    !validateRequired(disputeRequestData.agency_representative_document_files)
  ) {
    valid = false;
    setError("agency_representative_document_files", "يجب رفع الصورة");
  } else if (
    disputeRequestData.agency_representative_document_files &&
    !validateFileSizeDispute(
      disputeRequestData.agency_representative_document_files,
      5242880,
    )
  ) {
    valid = false;
    setError(
      "agency_representative_document_files",
      "لا يجب أن يتجاوز 5 ميجابايت",
    );
  } else if (
    disputeRequestData.agency_representative_document_files &&
    !validateFileTypeDispute(
      disputeRequestData.agency_representative_document_files,
    )
  ) {
    valid = false;
    setError(
      "agency_representative_document_files",
      "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG",
    );
  } else {
    setError("agency_representative_document_files");
  }
  if (!validateRequired(disputeRequestData.governorate_id)) {
    valid = false;
    setError("governorate_id", "يجب اختيار المحافظة");
  } else {
    setError("governorate_id", "");
  }
  if (!validateRequired(disputeRequestData.district_id)) {
    valid = false;
    setError("district_id", "يجب اختيار المأمورية");
  } else {
    setError("district_id", "");
  }
  if (!validateRequired(disputeRequestData.tax_type)) {
    valid = false;
    setError("tax_type", "يجب اختيار نوع الضريبة");
  } else {
    setError("tax_type", "");
  }
  if (!validateRequired(disputeRequestData.exploitation_type)) {
    valid = false;
    setError("exploitation_type", "يجب اختيار نوع الاستغلال");
  } else {
    setError("exploitation_type", "");
  }
  if (!validateRequired(disputeRequestData.activity_type)) {
    valid = false;
    setError("activity_type", "يجب إدخال نوع النشاط");
  } else {
    setError("activity_type", "");
  }
  if (!validateRequired(disputeRequestData.tax_period)) {
    valid = false;
    setError("tax_period", "يجب اختيار الفترة الضريبية");
  } else {
    setError("tax_period", "");
  }
  if (!validateRequired(disputeRequestData.property_address)) {
    valid = false;
    setError("property_address", "يجب إدخال العنوان");
  } else {
    setError("property_address", "");
  }
  if (!validateRequired(disputeRequestData.activity_date_from)) {
    valid = false;
    setError("activity_date_from", "يجب اختيار تاريخ إقامة النشاط من");
  } else {
    setError("activity_date_from", "");
  }
  if (!validateRequired(disputeRequestData.activity_date_to)) {
    valid = false;
    setError("activity_date_to", "يجب اختيار تاريخ إقامة النشاط إلى");
  } else {
    setError("activity_date_to", "");
  }
  if (!validateRequired(disputeRequestData.dispute_subject)) {
    valid = false;
    setError("dispute_subject", "يجب إدخال موضوع المنازعة");
  } else {
    setError("dispute_subject", "");
  }
  if (!validateRequired(disputeRequestData.disputed_annual_base_value)) {
    valid = false;
    setError(
      "disputed_annual_base_value",
      "يجب إدخال قيمة الوعاء السنوي المتنازع عليه",
    );
  } else {
    setError("disputed_annual_base_value", "");
  }
  if (!validateRequired(disputeRequestData.disputed_annual_tax_value)) {
    valid = false;
    setError(
      "disputed_annual_tax_value",
      "يجب إدخال قيمة الضريبة السنوية المتنازع عليها",
    );
  } else {
    setError("disputed_annual_tax_value", "");
  }
  if (!validateRequired(disputeRequestData.disputed_tax_value)) {
    valid = false;
    setError("disputed_tax_value", "يجب إدخال قيمة الضريبة المتنازع عليها");
  } else {
    setError("disputed_tax_value", "");
  }
  if (!validateRequired(disputeRequestData.disputed_increase_value)) {
    valid = false;
    setError(
      "disputed_increase_value",
      "يجب إدخال قيمة الزيادة (الغرامة) المتنازع عليها",
    );
  } else {
    setError("disputed_increase_value", "");
  }
  if (!validateRequired(disputeRequestData.dispute_reviewer)) {
    valid = false;
    setError(
      "dispute_reviewer",
      "يجب اختيار الجهة المنظور أمامها النزاع حاليا",
    );
  } else {
    setError("dispute_reviewer", "");
  }
  if (!validateRequired(disputeRequestData.appeal_committee)) {
    valid = false;
    setError("appeal_committee", "يجب إدخال لجنة الطعن");
  } else {
    setError("appeal_committee", "");
  }
  if (!validateRequired(disputeRequestData.appeal_number)) {
    valid = false;
    setError("appeal_number", "يجب إدخال رقم الطعن");
  } else {
    setError("appeal_number", "");
  }
  if (!validateRequired(disputeRequestData.appeal_date)) {
    valid = false;
    setError("appeal_date", "يجب اختيار تاريخ الطعن");
  } else {
    setError("appeal_date", "");
  }
  if (!validateRequired(disputeRequestData.court)) {
    valid = false;
    setError("court", "يجب إدخال المحكمة");
  } else {
    setError("court", "");
  }
  if (!validateRequired(disputeRequestData.lawsuit_number)) {
    valid = false;
    setError("lawsuit_number", "يجب إدخال رقم الدعوى");
  } else {
    setError("lawsuit_number", "");
  }
  if (!validateRequired(disputeRequestData.filing_lawsuit_date)) {
    valid = false;
    setError("filing_lawsuit_date", "يجب اختيار تاريخ إيداع الدعوى");
  } else {
    setError("filing_lawsuit_date", "");
  }
  if (!validateRequired(disputeRequestData.activity_address)) {
    valid = false;
    setError("activity_address", "يجب إدخال عنوان النشاط");
  } else {
    setError("activity_address", "");
  }
  if (!validateRequired(disputeRequestData.appeal_insurance_voucher)) {
    valid = false;
    setError("appeal_insurance_voucher", "يجب رفع الصورة");
  } else if (
    disputeRequestData.appeal_insurance_voucher &&
    !validateFileSizeDispute(
      disputeRequestData.appeal_insurance_voucher,
      5242880,
    )
  ) {
    valid = false;
    setError("appeal_insurance_voucher", "لا يجب أن يتجاوز 5 ميجابايت");
  } else if (
    disputeRequestData.appeal_insurance_voucher &&
    !validateFileTypeDispute(disputeRequestData.appeal_insurance_voucher)
  ) {
    valid = false;
    setError(
      "appeal_insurance_voucher",
      "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG",
    );
  } else {
    setError("appeal_insurance_voucher");
  }
  if (!validateRequired(disputeRequestData.tax_notification_form)) {
    valid = false;
    setError("tax_notification_form", "يجب رفع الصورة");
  } else if (
    disputeRequestData.tax_notification_form &&
    !validateFileSizeDispute(disputeRequestData.tax_notification_form, 5242880)
  ) {
    valid = false;
    setError("tax_notification_form", "لا يجب أن يتجاوز 5 ميجابايت");
  } else if (
    disputeRequestData.tax_notification_form &&
    !validateFileTypeDispute(disputeRequestData.tax_notification_form)
  ) {
    valid = false;
    setError("tax_notification_form", "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG");
  } else {
    setError("tax_notification_form");
  }
  if (
    !validateRequired(disputeRequestData.court_case_registration_certificate)
  ) {
    valid = false;
    setError("court_case_registration_certificate", "يجب رفع الصورة");
  } else if (
    disputeRequestData.court_case_registration_certificate &&
    !validateFileSizeDispute(
      disputeRequestData.court_case_registration_certificate,
      5242880,
    )
  ) {
    valid = false;
    setError(
      "court_case_registration_certificate",
      "لا يجب أن يتجاوز 5 ميجابايت",
    );
  } else if (
    disputeRequestData.court_case_registration_certificate &&
    !validateFileTypeDispute(
      disputeRequestData.court_case_registration_certificate,
    )
  ) {
    valid = false;
    setError(
      "court_case_registration_certificate",
      "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG",
    );
  } else {
    setError("court_case_registration_certificate");
  }
  return valid;
};

const DisputeRequestData = ({
  user,
  taxDisputeSubmitterCharacter,
  govs,
  taxTypes,
  exploitationTypes,
  taxPeriods,
  disputeReviewrs,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [backendError, setBackendError] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [isCheckedEmail, setIsCheckedEmail] = useState(false);
  const [isCheckedAccuracyFirstSession, setIsCheckedAccuracyFirstSession] =
    useState(false);
  const [disputeRequestData, setDisputeRequestData] = useState({
    first_name: null,
    rest_name: null,
    correspondence_address: null,
    submitter_request_character: null,
    agency_representative_document_files: null,
    tax_type: null,
    dispute_subject: null,
    disputed_annual_base_value: null,
    disputed_annual_tax_value: null,
    disputed_tax_value: null,
    disputed_increase_value: null,
    dispute_reviewer: null,
    property_address: null,
    exploitation_type: null,
    tax_period: null,
    activity_address: null,
    activity_type: null,
    activity_date_from: null,
    activity_date_to: null,
    appeal_committee: null,
    appeal_number: null,
    appeal_date: null,
    appeal_insurance_voucher: null,
    tax_notification_form: null,
    court: null,
    lawsuit_number: null,
    filing_lawsuit_date: null,
    court_case_registration_certificate: null,
    acknowledge_email: false,
    acknowledge_accuracy_register_data_with_doc_first_session: false,
  });
  const [validFields, setValidFields] = useState({
    submitter_request_character: false,
    first_name: false,
    rest_name: false,
    correspondence_address: false,
    agency_representative_document_files: false,
    governorate_id: false,
    district_id: false,
    tax_type: false,
    exploitation_type: false,
    activity_type: false,
    tax_period: false,
    property_address: false,
    activity_date_from: false,
    activity_date_to: false,
    dispute_subject: false,
    disputed_annual_base_value: false,
    disputed_annual_tax_value: false,
    disputed_tax_value: false,
    disputed_increase_value: false,
    dispute_reviewer: false,
    appeal_committee: false,
    appeal_number: false,
    appeal_date: false,
    court: false,
    lawsuit_number: false,
    filing_lawsuit_date: false,
    activity_address: false,
    appeal_insurance_voucher: false,
    tax_notification_form: false,
    court_case_registration_certificate: false,
    acknowledge_email: false,
    acknowledge_accuracy_register_data_with_doc_first_session: false,
  });
  const [error_new_user, setNewUserError] = useState(
    Object.keys(disputeRequestData).reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {}),
  );
  const [fileInputKeys, setFileInputKeys] = useState({
    agency: Date.now(),
    appeal: Date.now(),
    tax: Date.now(),
    court: Date.now(),
  });

  function setError(key, value) {
    setNewUserError((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  const ValidateDisputeFields = async (
    disputeRequestData,
    fieldName,
    value,
  ) => {
    let valid = true;
    switch (fieldName) {
      case "submitter_request_character":
        if (!validateRequired(value)) {
          valid = false;
          setError("submitter_request_character", "يجب اختيار صفة مقدم الطلب");
        } else {
          setError("submitter_request_character", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "first_name":
        if (!validateRequired(value)) {
          valid = false;
          setError("first_name", "يجب إدخال الاسم");
        } else {
          setError("first_name", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "rest_name":
        if (!validateRequired(value)) {
          valid = false;
          setError("rest_name", "يجب إدخال الاسم");
        } else {
          setError("rest_name", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "correspondence_address":
        if (!validateRequired(value)) {
          valid = false;
          setError("correspondence_address", "يجب إدخال العنوان");
        } else {
          setError("correspondence_address", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "agency_representative_document_files":
        if (!validateRequired(value)) {
          valid = false;
          setError("agency_representative_document_files", "يجب رفع الصورة");
        } else if (value && !validateFileSizeDispute(value, 5242880)) {
          valid = false;
          setError(
            "agency_representative_document_files",
            "لا يجب أن يتجاوز 5 ميجابايت",
          );
        } else if (value && !(await validateFileTypeDispute(value))) {
          valid = false;
          setError(
            "agency_representative_document_files",
            "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG",
          );
        } else {
          setError("agency_representative_document_files", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "governorate_id":
        if (!validateRequired(value)) {
          valid = false;
          setError("governorate_id", "يجب اختيار المحافظة");
        } else {
          setError("governorate_id", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "district_id":
        if (!validateRequired(value)) {
          valid = false;
          setError("district_id", "يجب اختيار المأمورية");
        } else {
          setError("district_id", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "tax_type":
        if (!validateRequired(value)) {
          valid = false;
          setError("tax_type", "يجب اختيار نوع الضريبة");
        } else {
          setError("tax_type", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "exploitation_type":
        if (!validateRequired(value)) {
          valid = false;
          setError("exploitation_type", "يجب اختيار نوع الاستغلال");
        } else {
          setError("exploitation_type", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "activity_type":
        if (!validateRequired(value)) {
          valid = false;
          setError("activity_type", "يجب إدخال نوع النشاط");
        } else {
          setError("activity_type", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "tax_period":
        if (!validateRequired(value)) {
          valid = false;
          setError("tax_period", "يجب اختيار الفترة الضريبية");
        } else {
          setError("tax_period", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "property_address":
        if (!validateRequired(value)) {
          valid = false;
          setError("property_address", "يجب إدخال العنوان");
        } else {
          setError("property_address", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "activity_date_from":
        if (!validateRequired(value)) {
          valid = false;
          setError("activity_date_from", "يجب اختيار تاريخ إقامة النشاط من");
        } else {
          setError("activity_date_from", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "activity_date_to":
        if (!validateRequired(value)) {
          valid = false;
          setError("activity_date_to", "يجب اختيار تاريخ إقامة النشاط إلى");
        } else {
          setError("activity_date_to", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "dispute_subject":
        if (!validateRequired(value)) {
          valid = false;
          setError("dispute_subject", "يجب إدخال موضوع المنازعة");
        } else {
          setError("dispute_subject", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "disputed_annual_base_value":
        if (!validateRequired(value)) {
          valid = false;
          setError(
            "disputed_annual_base_value",
            "يجب إدخال قيمة الوعاء السنوي المتنازع عليه",
          );
        } else {
          setError("disputed_annual_base_value", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "disputed_annual_tax_value":
        if (!validateRequired(value)) {
          valid = false;
          setError(
            "disputed_annual_tax_value",
            "يجب إدخال قيمة الضريبة السنوية المتنازع عليها",
          );
        } else {
          setError("disputed_annual_tax_value", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "disputed_tax_value":
        if (!validateRequired(value)) {
          valid = false;
          setError(
            "disputed_tax_value",
            "يجب إدخال قيمة الضريبة المتنازع عليها",
          );
        } else {
          setError("disputed_tax_value", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "disputed_increase_value":
        if (!validateRequired(value)) {
          valid = false;
          setError(
            "disputed_increase_value",
            "يجب إدخال قيمة الزيادة (الغرامة) المتنازع عليها",
          );
        } else {
          setError("disputed_increase_value", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "dispute_reviewer":
        if (!validateRequired(value)) {
          valid = false;
          setError(
            "dispute_reviewer",
            "يجب اختيار الجهة المنظور أمامها النزاع حاليا",
          );
        } else {
          setError("dispute_reviewer", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "appeal_committee":
        if (!validateRequired(value)) {
          valid = false;
          setError("appeal_committee", "يجب إدخال لجنة الطعن");
        } else {
          setError("appeal_committee", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "appeal_number":
        if (!validateRequired(value)) {
          valid = false;
          setError("appeal_number", "يجب إدخال رقم الطعن");
        } else {
          setError("appeal_number", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "appeal_date":
        if (!validateRequired(value)) {
          valid = false;
          setError("appeal_date", "يجب اختيار تاريخ الطعن");
        } else {
          setError("appeal_date", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "court":
        if (!validateRequired(value)) {
          valid = false;
          setError("court", "يجب إدخال المحكمة");
        } else {
          setError("court", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "lawsuit_number":
        if (!validateRequired(value)) {
          valid = false;
          setError("lawsuit_number", "يجب إدخال رقم الدعوى");
        } else {
          setError("lawsuit_number", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "filing_lawsuit_date":
        if (!validateRequired(value)) {
          valid = false;
          setError("filing_lawsuit_date", "يجب اختيار تاريخ إيداع الدعوى");
        } else {
          setError("filing_lawsuit_date", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "activity_address":
        if (!validateRequired(value)) {
          valid = false;
          setError("activity_address", "يجب إدخال عنوان النشاط");
        } else {
          setError("activity_address", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "appeal_insurance_voucher":
        if (!validateRequired(value)) {
          valid = false;
          setError("appeal_insurance_voucher", "يجب رفع الصورة");
        } else if (value && !validateFileSizeDispute(value, 5242880)) {
          valid = false;
          setError("appeal_insurance_voucher", "لا يجب أن يتجاوز 5 ميجابايت");
        } else if (value && !(await validateFileTypeDispute(value))) {
          valid = false;
          setError(
            "appeal_insurance_voucher",
            "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG",
          );
        } else {
          setError("appeal_insurance_voucher", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "tax_notification_form":
        if (!validateRequired(value)) {
          valid = false;
          setError("tax_notification_form", "يجب رفع الصورة");
        } else if (value && !validateFileSizeDispute(value, 5242880)) {
          valid = false;
          setError("tax_notification_form", "لا يجب أن يتجاوز 5 ميجابايت");
        } else if (value && !(await validateFileTypeDispute(value))) {
          valid = false;
          setError(
            "tax_notification_form",
            "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG",
          );
        } else {
          setError("tax_notification_form", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "court_case_registration_certificate":
        if (!validateRequired(value)) {
          valid = false;
          setError("court_case_registration_certificate", "يجب رفع الصورة");
        } else if (value && !validateFileSizeDispute(value, 5242880)) {
          valid = false;
          setError(
            "court_case_registration_certificate",
            "لا يجب أن يتجاوز 5 ميجابايت",
          );
        } else if (value && !(await validateFileTypeDispute(value))) {
          valid = false;
          setError(
            "court_case_registration_certificate",
            "يجب ان يكون PDF, JFIF, JPEG, JPG, PNG",
          );
        } else {
          setError("court_case_registration_certificate", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "acknowledge_email":
        if (value == false) {
          valid = false;
          setError(
            "acknowledge_email",
            "يجب أن تقر بأن البريد الإلكتروني المستخدم هو عنوان المراسلة",
          );
        } else {
          setError("acknowledge_email", "");
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      case "acknowledge_accuracy_register_data_with_doc_first_session":
        if (value == false) {
          valid = false;
          setError(
            "acknowledge_accuracy_register_data_with_doc_first_session",
            "يجب أن تقر بصحة البيانات المقدمة مع تقديم المستندات المطلوبة فى تاريخ أول جلسة",
          );
        } else {
          setError(
            "acknowledge_accuracy_register_data_with_doc_first_session",
            "",
          );
        }
        setValidFields((prev) => ({
          ...prev,
          [fieldName]: valid,
        }));
        break;
      default:
        break;
    }
    return valid;
  };
  function handleChangeDisputeSubmitterCharacter(
    parentCompenent,
    compenent,
    key,
    value,
  ) {
    handleChange(parentCompenent, compenent, key, value);

    if (["1", "2", "3"].includes(value)) {
      handleChange(parentCompenent, compenent, "first_name", null);
      handleChange(parentCompenent, compenent, "rest_name", null);
      handleChange(
        parentCompenent,
        compenent,
        "agency_representative_document_files",
        null,
      );
      setValidFields((prev) => ({
        ...prev,
        first_name: true,
        rest_name: true,
        agency_representative_document_files: true,
      }));
      setNewUserError((prev) => ({
        ...prev,
        first_name: "",
        rest_name: "",
        agency_representative_document_files: "",
      }));
    } else {
      // setFileInputKeys((prev) => ({ ...prev, agency: Date.now() }));
      setValidFields((prev) => ({
        ...prev,
        first_name: disputeRequestData.first_name
          ? ValidateDisputeFields(
              disputeRequestData,
              "first_name",
              disputeRequestData.first_name,
            )
          : false,
        rest_name: disputeRequestData.rest_name
          ? ValidateDisputeFields(
              disputeRequestData,
              "rest_name",
              disputeRequestData.rest_name,
            )
          : false,
        agency_representative_document_files:
          disputeRequestData.agency_representative_document_files
            ? ValidateDisputeFields(
                disputeRequestData,
                "agency_representative_document_files",
                disputeRequestData.agency_representative_document_files,
              )
            : false,
      }));
    }
  }
  const [districts, setDistricts] = useState([]);

  function handleChangeGov(parentCompenent, compenent, key, value) {
    // reset next levels
    resetDistrict();
    //load districts by gov id
    if (value !== "" && value) {
      getDisputeDistricts(value)
        .then((res) => setDistricts(res.data.data))
        .catch((err) => {
          console.log(err);
        });
    } else {
      setDistricts([]);
    }
    handleChange(parentCompenent, compenent, key, value);
  }

  function handleChangeDistrict(pc, c, key, value) {
    handleChange("", "", key, value);
  }
  function handleChangeTaxType(pc, c, key, value) {
    handleChange("", "", key, value);
    if (parseInt(value) === 2) {
      handleChange("", "", "dispute_reviewer", 1);
      handleChange("", "", "exploitation_type", null);
      handleChange("", "", "property_address", null);
      handleChange("", "", "tax_period", null);
      handleChange("", "", "disputed_annual_tax_value", null);
      handleChange("", "", "disputed_annual_base_value", null);
      setValidFields((prev) => ({
        ...prev,
        exploitation_type: true,
        property_address: true,
        tax_period: true,
        disputed_annual_base_value: true,
        disputed_annual_tax_value: true,
        activity_address: disputeRequestData.activity_address
          ? ValidateDisputeFields(
              disputeRequestData,
              "activity_address",
              disputeRequestData.activity_address,
            )
          : false,
        activity_type: disputeRequestData.activity_type
          ? ValidateDisputeFields(
              disputeRequestData,
              "activity_type",
              disputeRequestData.activity_type,
            )
          : false,
        activity_date_from: disputeRequestData.activity_date_from
          ? ValidateDisputeFields(
              disputeRequestData,
              "activity_date_from",
              disputeRequestData.activity_date_from,
            )
          : false,
        activity_date_to: disputeRequestData.activity_date_to
          ? ValidateDisputeFields(
              disputeRequestData,
              "activity_date_to",
              disputeRequestData.activity_date_to,
            )
          : false,
        disputed_tax_value: disputeRequestData.disputed_tax_value
          ? ValidateDisputeFields(
              disputeRequestData,
              "disputed_tax_value",
              disputeRequestData.disputed_tax_value,
            )
          : false,
        disputed_increase_value: disputeRequestData.disputed_increase_value
          ? ValidateDisputeFields(
              disputeRequestData,
              "disputed_increase_value",
              disputeRequestData.disputed_increase_value,
            )
          : false,
      }));
      setNewUserError((prev) => ({
        ...prev,
        exploitation_type: "",
        property_address: "",
        tax_period: "",
        disputed_annual_base_value: "",
        disputed_annual_tax_value: "",
      }));
      handleChangeDisputeReviewer(pc, c, "dispute_reviewer", 1);
    } else if (parseInt(value) === 1) {
      handleChange("", "", "activity_address", null);
      handleChange("", "", "activity_type", null);
      handleChange("", "", "activity_date_from", null);
      handleChange("", "", "activity_date_to", null);
      handleChange("", "", "disputed_tax_value", null);
      handleChange("", "", "disputed_increase_value", null);
      setValidFields((prev) => ({
        ...prev,
        activity_address: true,
        activity_type: true,
        activity_date_from: true,
        activity_date_to: true,
        disputed_tax_value: true,
        disputed_increase_value: true,
        exploitation_type: disputeRequestData.exploitation_type
          ? ValidateDisputeFields(
              disputeRequestData,
              "exploitation_type",
              disputeRequestData.exploitation_type,
            )
          : false,
        property_address: disputeRequestData.property_address
          ? ValidateDisputeFields(
              disputeRequestData,
              "property_address",
              disputeRequestData.property_address,
            )
          : false,
        tax_period: disputeRequestData.tax_period
          ? ValidateDisputeFields(
              disputeRequestData,
              "tax_period",
              disputeRequestData.tax_period,
            )
          : false,
        disputed_annual_base_value:
          disputeRequestData.disputed_annual_base_value
            ? ValidateDisputeFields(
                disputeRequestData,
                "disputed_annual_base_value",
                disputeRequestData.disputed_annual_base_value,
              )
            : false,
        disputed_annual_tax_value: disputeRequestData.disputed_annual_tax_value
          ? ValidateDisputeFields(
              disputeRequestData,
              "disputed_annual_tax_value",
              disputeRequestData.disputed_annual_tax_value,
            )
          : false,
      }));
      setNewUserError((prev) => ({
        ...prev,
        activity_address: "",
        activity_type: "",
        activity_date_from: "",
        activity_date_to: "",
        disputed_tax_value: "",
        disputed_increase_value: "",
      }));
    }
  }
  function handleChangeDisputeReviewer(pc, c, key, value) {
    if (parseInt(value) === 1) {
      if (!disputeRequestData.court_case_registration_certificate) {
        setFileInputKeys((prev) => ({ ...prev, court: Date.now() }));
      }
      handleChange("", "", "appeal_committee", null);
      handleChange("", "", "appeal_number", null);
      handleChange("", "", "appeal_date", null);
      handleChange("", "", "appeal_insurance_voucher", null);
      handleChange("", "", "tax_notification_form", null);
      setValidFields((prev) => ({
        ...prev,
        appeal_committee: true,
        appeal_number: true,
        appeal_date: true,
        tax_notification_form: true,
        appeal_insurance_voucher: true,
        court: disputeRequestData.court
          ? ValidateDisputeFields(
              disputeRequestData,
              "court",
              disputeRequestData.court,
            )
          : false,
        lawsuit_number: disputeRequestData.lawsuit_number
          ? ValidateDisputeFields(
              disputeRequestData,
              "lawsuit_number",
              disputeRequestData.lawsuit_number,
            )
          : false,
        filing_lawsuit_date: disputeRequestData.filing_lawsuit_date
          ? ValidateDisputeFields(
              disputeRequestData,
              "filing_lawsuit_date",
              disputeRequestData.filing_lawsuit_date,
            )
          : false,
        court_case_registration_certificate:
          disputeRequestData.court_case_registration_certificate
            ? ValidateDisputeFields(
                disputeRequestData,
                "court_case_registration_certificate",
                disputeRequestData.court_case_registration_certificate,
              )
            : false,
      }));
      setNewUserError((prev) => ({
        ...prev,
        appeal_committee: "",
        appeal_number: "",
        appeal_date: "",
        tax_notification_form: "",
        appeal_insurance_voucher: "",
      }));
    } else if (parseInt(value) === 2) {
      if (!disputeRequestData.tax_notification_form) {
        setFileInputKeys((prev) => ({
          ...prev,
          tax: Date.now(),
        }));
      }
      if (!disputeRequestData.appeal_insurance_voucher) {
        setFileInputKeys((prev) => ({
          ...prev,
          appeal: Date.now(),
        }));
      }

      handleChange("", "", "court", null);
      handleChange("", "", "lawsuit_number", null);
      handleChange("", "", "filing_lawsuit_date", null);
      handleChange("", "", "court_case_registration_certificate", null);
      setValidFields((prev) => ({
        ...prev,
        court: true,
        lawsuit_number: true,
        filing_lawsuit_date: true,
        court_case_registration_certificate: true,
        appeal_committee: disputeRequestData.appeal_committee
          ? ValidateDisputeFields(
              disputeRequestData,
              "appeal_committee",
              disputeRequestData.appeal_committee,
            )
          : false,
        appeal_number: disputeRequestData.appeal_number
          ? ValidateDisputeFields(
              disputeRequestData,
              "appeal_number",
              disputeRequestData.appeal_number,
            )
          : false,
        appeal_date: disputeRequestData.appeal_date
          ? ValidateDisputeFields(
              disputeRequestData,
              "appeal_date",
              disputeRequestData.appeal_date,
            )
          : false,
        tax_notification_form: disputeRequestData.tax_notification_form
          ? ValidateDisputeFields(
              disputeRequestData,
              "tax_notification_form",
              disputeRequestData.tax_notification_form,
            )
          : false,
        appeal_insurance_voucher: disputeRequestData.appeal_insurance_voucher
          ? ValidateDisputeFields(
              disputeRequestData,
              "appeal_insurance_voucher",
              disputeRequestData.appeal_insurance_voucher,
            )
          : false,
      }));
      setNewUserError((prev) => ({
        ...prev,
        court: "",
        lawsuit_number: "",
        filing_lawsuit_date: "",
        court_case_registration_certificate: "",
      }));
    } else {
      handleChange("", "", "appeal_committee", null);
      handleChange("", "", "appeal_number", null);
      handleChange("", "", "appeal_date", null);
      handleChange("", "", "appeal_insurance_voucher", null);
      handleChange("", "", "tax_notification_form", null);
      handleChange("", "", "court", null);
      handleChange("", "", "lawsuit_number", null);
      handleChange("", "", "filing_lawsuit_date", null);
      handleChange("", "", "court_case_registration_certificate", null);
      setNewUserError((prev) => ({
        ...prev,
        appeal_committee: "",
        appeal_number: "",
        appeal_date: "",
        tax_notification_form: "",
        appeal_insurance_voucher: "",
        court: "",
        lawsuit_number: "",
        filing_lawsuit_date: "",
        court_case_registration_certificate: "",
      }));
    }
    handleChange("", "", key, value);
  }
  function handleChange(pc, c, key, value) {
    if (key === "acknowledge_email") {
      setIsCheckedEmail(true); // Mark that the email checkbox has been interacted with
    } else if (
      key === "acknowledge_accuracy_register_data_with_doc_first_session"
    ) {
      setIsCheckedAccuracyFirstSession(true);
    }
    // validateRegisterFields(setError, new_user, key, value);
    setIsValid(ValidateDisputeFields(disputeRequestData, key, value));
    setDisputeRequestData((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  const handleChangeActivityDateFrom = (pc, c, key, value) => {
    handleChange(pc, c, key, value);
    handleChange(pc, c, "activity_date_to", null);
    setNewUserError((prev) => ({
      ...prev,
      activity_date_to: "",
    }));
  };
  const resetDistrict = () => {
    // reset districts
    setDistricts([]);
    handleChange("", "", "district_id", null);
    setNewUserError((prev) => ({
      ...prev,
      district_id: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setBackendError(null);
    // const isValid = ValidateDisputeRequest(setError, disputeRequestData);
    // if (isValid) {
    const formData = new FormData();

    // Append all the form fields to the FormData object
    for (const key in disputeRequestData) {
      if (
        disputeRequestData[key] !== null &&
        disputeRequestData[key] !== undefined
      ) {
        formData.append(key, disputeRequestData[key]);
      }
    }
    if (disputeRequestData.filing_lawsuit_date) {
      formData.append(
        "filing_lawsuit_date",
        moment(disputeRequestData.filing_lawsuit_date).format("YYYY-MM-DD"),
      );
    }
    if (disputeRequestData.appeal_date) {
      formData.append(
        "appeal_date",
        moment(disputeRequestData.appeal_date).format("YYYY-MM-DD"),
      );
    }
    if (disputeRequestData.activity_date_from) {
      formData.append(
        "activity_date_from",
        moment(disputeRequestData.activity_date_from).format("YYYY-MM-DD"),
      );
    }
    if (disputeRequestData.activity_date_to) {
      formData.append(
        "activity_date_to",
        moment(disputeRequestData.activity_date_to).format("YYYY-MM-DD"),
      );
    }
    try {
      // Use the FormData object to send the request
      const response = await store_dispute_request(formData);
      navigate("/tax-dispute/message-confirmation", {
        state: { message: response?.data?.message, disputeRequestData: true },
      });
    } catch (error) {
      setBackendError(error.response?.data?.message || "خطأ في إرسال البيانات");
      window.scrollTo(0, 0);
    } finally {
      setIsLoading(false);
    }
    // }
    // Create a new FormData object
  };

  const [fileName, setFileName] = useState("إرفاق ملف");

  console.log(
    disputeRequestData?.court_case_registration_certificate,
    typeof disputeRequestData?.court_case_registration_certificate,
  );

  useEffect(() => {
    if (disputeRequestData.court_case_registration_certificate !== null) {
      disputeRequestData.court_case_registration_certificate.name = fileName;
    }
  }, [fileName]);

  useEffect(() => {
    const allValid = Object.values(validFields).every(Boolean);
    // console.log('fffff', validFields)
    setIsValid(allValid);
  }, [validFields]);
  // Generate options for select components
  const generateOptions = (data) =>
    data.map(({ id, name }) => ({ value: id.toString(), label: name }));
  return (
    <>
      {backendError && (
        <div
          className="alert alert-danger text-center mt-3"
          id="backend_error"
          role="alert"
        >
          {backendError}
        </div>
      )}
      <Fragment>
        <div className={`${stylesRequestData.box} box pdf-box`}>
          <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
            بيانات مقدم الطلب
          </h4>
          <div className="row">
            <div className="col-md-4">
              <SearchSelectElement
                mb4="mb-4"
                labelHtmlFor="submitter_request_character"
                labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
                labelText="صفة مقدم الطلب"
                selectClassName={`${stylesRequestData["form-select"]} form-select`}
                selectID="submitter_request_character"
                name="submitter_request_character"
                options={generateOptions(taxDisputeSubmitterCharacter)}
                default="أختار صفة مقدم الطلب.."
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={disputeRequestData.submitter_request_character}
                onChange={handleChangeDisputeSubmitterCharacter}
                pText={error_new_user.submitter_request_character}
                isClearable={true}
              />
            </div>
            {disputeRequestData.submitter_request_character && (
              <>
                {["4", "5"].includes(
                  disputeRequestData.submitter_request_character,
                ) && (
                  <Fragment>
                    <div className="col-md-4">
                      <InputElementDispute
                        value={disputeRequestData.first_name || ""}
                        disabled={false}
                        name="first_name"
                        onChange={handleChange}
                        mb4="mb-4"
                        labelHtmlFor="first_name"
                        labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                        labelText="الاسم الاول للممول/المكلف"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="first_name_input"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={error_new_user.first_name}
                        allowedPattern={
                          /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/
                        }
                        maxLength={24}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputElementDispute
                        value={disputeRequestData.rest_name || ""}
                        disabled={false}
                        name="rest_name"
                        mb4="mb-4"
                        labelHtmlFor="rest_name"
                        labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                        labelText=" باقى الاسم للممول/المكلف"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="rest_name_input"
                        onChange={handleChange}
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        allowedPattern={
                          /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/
                        }
                        maxLength={64}
                        pText={error_new_user.rest_name}
                      />
                    </div>
                  </Fragment>
                )}
                <div className="col-md-4">
                  <InputElementDispute
                    value={user.first_name || ""}
                    disabled={true}
                    name="tax_payer_first_name"
                    mb4="mb-4"
                    labelHtmlFor="tax_payer_first_name"
                    labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                    labelText={
                      ["4", "5"].includes(
                        disputeRequestData.submitter_request_character,
                      )
                        ? " الأسم الاول لمقدم الطلب"
                        : "الاسم الاول للممول/المكلف"
                    }
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="tax_payer_first_name"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  />
                </div>
                <div className="col-md-4">
                  <InputElementDispute
                    value={
                      `${user.father_name} ${user.grandfather_name} ${user.family_name}` ||
                      ""
                    }
                    disabled={true}
                    name="tax_payer_rest_name"
                    mb4="mb-4"
                    labelHtmlFor="tax_payer_rest_name"
                    labelClassName={`${stylesRequestData["form-label"]} form-label`}
                    labelText={
                      ["4", "5"].includes(
                        disputeRequestData.submitter_request_character,
                      )
                        ? "باقى الاسم لمقدم الطلب"
                        : "باقى الاسم للممول/المكلف"
                    }
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="tax_payer_rest_name"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  />
                </div>
                <div className="col-md-4">
                  <InputElementDispute
                    name="email"
                    mb4="mb-4"
                    labelHtmlFor="email"
                    labelClassName={`${stylesRequestData["form-label"]} form-label`}
                    labelText="البريد الإلكترونى"
                    inputType="email"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="email"
                    value={user.email}
                    disabled={true}
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  />
                </div>
                <div className="col-md-4">
                  <InputElementDispute
                    value={user.phone_number || ""}
                    disabled={true}
                    name="phone_number"
                    mb4="mb-4"
                    labelHtmlFor="phone_number"
                    labelClassName={`${stylesRequestData["form-label"]} form-label`}
                    labelText="رقم الهاتف"
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="phone_number"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    maxLength={11}
                  />
                </div>
                <div className="col-md-4">
                  <InputElementDispute
                    value={user.nationality?.value || ""}
                    disabled={true}
                    name="natioanlity"
                    mb4="mb-4"
                    labelHtmlFor="natioanlity"
                    labelClassName={`${stylesRequestData["form-label"]} form-label`}
                    labelText="الجنسية"
                    inputType="text"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="natioanlity"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  />
                </div>
                {user.nationality?.key === "EG" ? (
                  <Fragment>
                    <div className="col-md-4">
                      <InputElementDispute
                        value={user.national_id || ""}
                        disabled={true}
                        name="national_id"
                        mb4="mb-4"
                        labelHtmlFor="national_id"
                        labelClassName={`  ${stylesRequestData["form-label"]} form-label`}
                        labelText="الرقم القومى  "
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="national_id"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      />
                    </div>
                    {user.national_id_file &&
                      user.national_id_file.full_url && (
                        <div className="col-md-4">
                          <InputElementDispute
                            value={"الملف"}
                            disabled={true}
                            name="national_id_file"
                            mb4="mb-4"
                            labelHtmlFor="national_id_file"
                            labelClassName={`  ${stylesRequestData["form-label"]} form-label`}
                            labelText="صورة الرقم القومى"
                            inputType="text"
                            inputClassName={`${stylesRequestData["form-control"]} form-control`}
                            inputID="national_id_file"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            isIcon={user.national_id_file.full_url ?? ""}
                            idDownload={user?.profile?.id}
                            filedDownload="nationalIdFile"
                          />
                        </div>
                      )}
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className="col-md-4">
                      <InputElementDispute
                        value={user.passport_number}
                        disabled={true}
                        name="passport_number"
                        mb4="mb-4"
                        labelHtmlFor="passport_number"
                        labelClassName={` ${stylesRequestData["form-label"]} form-label`}
                        labelText="رقم جواز السفر  "
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="passport_number"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      />
                    </div>
                    {user.passport_number_file &&
                      user.passport_number_file.full_url && (
                        <div className="col-md-4">
                          <InputElementDispute
                            value={"الملف"}
                            disabled={true}
                            name="passport_number_file"
                            mb4="mb-4"
                            labelHtmlFor="passport_number_file"
                            labelClassName={`  ${stylesRequestData["form-label"]} form-label`}
                            labelText="صورة جواز السفر"
                            inputType="text"
                            inputClassName={`${stylesRequestData["form-control"]} form-control`}
                            inputID="passport_number_file"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            isIcon={user.passport_number_file.full_url ?? ""}
                            idDownload={user?.profile?.id}
                            filedDownload="passportNumFile"
                          />
                        </div>
                      )}
                  </Fragment>
                )}
                {["4", "5"].includes(
                  disputeRequestData.submitter_request_character,
                ) && (
                  <div className="col-md-4">
                    <InputElementDispute
                      mb4="mb-4"
                      key={`agency-${fileInputKeys.agency}`}
                      inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                      labelHtmlFor="agency_representative_document_files"
                      labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                      labelText="صورة سند التوكيل/سند التمثيل القانوني"
                      inputType="file"
                      tooltipText=" الحد الاقصي للملف 5 ميجا وصيغة الملف يجب ان تكون pdf, jpg , png , jpeg او jfif"
                      inputClassName={`${stylesRequestData["form-control"]} form-control`}
                      inputID="agency_representative_document_files"
                      name="agency_representative_document_files"
                      fileName="إرفاق ملف"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      icon="fa-solid fa-cloud-arrow-up"
                      accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                      pText={
                        error_new_user.agency_representative_document_files
                      }
                      onChange={handleChange}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        {disputeRequestData.submitter_request_character && (
          <>
            <div className={`${stylesRequestData.box} box pdf-box`}>
              {/* <div className="row"> */}
              <div className="col-md-12">
                <TextAreaElement
                  mb4="mb-4"
                  labelHtmlFor="correspondence_address"
                  labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
                  labelText="عنوان المراسلة"
                  teaxtAreaClassName="form-control"
                  teaxtAreaID="notes"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.correspondence_address}
                  value={disputeRequestData.correspondence_address || ""}
                  onChange={handleChange}
                  inputId="correspondence_address_input"
                  name="correspondence_address"
                  allowedPattern={
                    // /^(?!.*\.\d)(?!.*؟)[a-zA-Z\u0600-\u06FF0-9\s\-,.\/\\]*$/
                    /^(?!.*\.\d)(?!.*[؛،؟])[a-zA-Z0-9\s\-,.\/\\\u0621-\u064A\u066E-\u067F\u0681-\u06D5]*$/
                  }
                  disabled={false}
                  maxLength={100}
                />
              </div>
            </div>
          </>
        )}
      </Fragment>
      <div className="box pdf-box">
        <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
          تفاصيل الطلب
        </h4>
        <div className="row">
          <div className="col-lg-4 col-sm-6">
            <SearchSelectElement
              mb4="mb-4"
              labelHtmlFor="governorate_id"
              labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
              labelText="المحافظة"
              selectClassName={`${stylesRequestData["form-select"]} form-select`}
              selectID="governorate_id"
              inputId="governorate_id_input"
              name="governorate_id"
              options={generateOptions(govs)}
              default="أختار المحافظة .."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              pText={error_new_user.governorate_id}
              value={disputeRequestData.governorate_id}
              onChange={handleChangeGov}
              isClearable={true}
            />
          </div>
          <div className="col-lg-4 col-sm-6">
            <SearchSelectElement
              mb4="mb-4"
              labelHtmlFor="district_id"
              labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
              labelText="المأمورية"
              selectClassName={`${stylesRequestData["form-select"]} form-select`}
              selectID="district_id"
              inputId="district_id_input"
              name="district_id"
              options={generateOptions(districts)}
              default="أختار المأمورية   .."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              pText={error_new_user.district_id}
              value={disputeRequestData.district_id}
              onChange={handleChangeDistrict}
              isClearable={true}
            />
          </div>
          <div className="col-lg-4 col-sm-6">
            <SearchSelectElement
              mb4="mb-4"
              labelHtmlFor="tax_type"
              labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
              labelText="نوع الضريبة"
              selectClassName={`${stylesRequestData["form-select"]} form-select`}
              selectID="tax_type"
              inputId="tax_type_input"
              name="tax_type"
              options={generateOptions(taxTypes)}
              default="أختار نوع الضريبة   .."
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              pText={error_new_user.tax_type}
              value={disputeRequestData.tax_type}
              onChange={handleChangeTaxType}
              isClearable={true}
            />
          </div>

          {disputeRequestData.tax_type && (
            <div className="col-md-12">
              <TextAreaElement
                mb4="mb-4"
                labelHtmlFor={
                  parseInt(disputeRequestData.tax_type) === 1
                    ? "correspondence_address"
                    : "activity_address"
                }
                labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
                labelText={
                  parseInt(disputeRequestData.tax_type) === 1
                    ? "عنوان العقار"
                    : "عنوان النشاط"
                }
                teaxtAreaClassName="form-control"
                teaxtAreaID={
                  parseInt(disputeRequestData.tax_type) === 1
                    ? "property_address"
                    : "activity_address"
                }
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                inputId={
                  parseInt(disputeRequestData.tax_type) === 1
                    ? "correspondence_address_input"
                    : "activity_address_input"
                }
                pText={
                  parseInt(disputeRequestData.tax_type) == 1
                    ? error_new_user.property_address
                    : error_new_user.activity_address
                }
                value={
                  parseInt(disputeRequestData.tax_type) === 1
                    ? disputeRequestData.property_address || ""
                    : disputeRequestData.activity_address || ""
                }
                onChange={handleChange}
                name={
                  parseInt(disputeRequestData.tax_type) == 1
                    ? "property_address"
                    : "activity_address"
                }
                allowedPattern={
                  // /^(?!.*\.\d)(?!.*؟)[a-zA-Z\u0600-\u06FF0-9\s\-,.\/\\]*$/
                  /^(?!.*\.\d)(?!.*[؛،؟])[a-zA-Z0-9\s\-,.\/\\\u0621-\u064A\u066E-\u067F\u0681-\u06D5]*$/
                }
                disabled={false}
                maxLength={100}
              />
            </div>
          )}
        </div>
      </div>
      <div className="box pdf-box">
        <div className="row">
          {disputeRequestData.tax_type &&
            (parseInt(disputeRequestData.tax_type) === 1 ? (
              <>
                <div className="col-lg-4 col-sm-6">
                  <SearchSelectElement
                    mb4="mb-4"
                    labelHtmlFor="exploitation_type"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="نوع الاستغلال"
                    selectClassName={`${stylesRequestData["form-select"]} form-select`}
                    selectID="exploitation_type"
                    inputId="exploitation_type_input"
                    name="exploitation_type"
                    options={generateOptions(exploitationTypes)}
                    default=" نوع الاستغلال .."
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    pText={error_new_user.exploitation_type}
                    value={disputeRequestData.exploitation_type}
                    onChange={handleChange}
                    isClearable={true}
                  />
                </div>
                <div className="col-lg-4 col-sm-6">
                  <SearchSelectElement
                    mb4="mb-4"
                    labelHtmlFor="tax_period"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="الفترة الضريبية"
                    selectClassName={`${stylesRequestData["form-select"]} form-select`}
                    selectID="tax_period"
                    inputId="tax_period_input"
                    name="tax_period"
                    options={generateOptions(taxPeriods)}
                    default="الفترة الضريبية .."
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    pText={error_new_user.tax_period}
                    value={disputeRequestData.tax_period}
                    onChange={handleChange}
                    isClearable={true}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="col-lg-4 col-sm-6">
                  <InputElementDispute
                    mb4="mb-4"
                    labelHtmlFor="activity_type"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="نوع النشاط"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputType="text"
                    inputId="activity_type_input"
                    name="activity_type"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    pText={error_new_user.activity_type}
                    value={disputeRequestData.activity_type || ""}
                    onChange={handleChange}
                    maxLength={64}
                    allowedPattern={
                      // /^(?!.*؟)[\u0600-\u06FFa-zA-Z\s]*$/
                      /^(?!.*[؟؛،])[\u0600-\u06FFa-zA-Z\s]*$/
                    }
                  />
                </div>
                <div className="col-lg-4 col-sm-6">
                  <DatePickerFormated
                    name="activity_date_from"
                    name_datepicker="activity_date_from"
                    mb4="mb-4"
                    labelHtmlFor="activity_date_from"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="تاريخ إقامة النشاط من"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputType="datePicker"
                    inputId="activity_date_from_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    pText={error_new_user.activity_date_from}
                    minYear="1990"
                    minDate={moment("1990-01-01").toDate()}
                    maxDate={moment()}
                    value={disputeRequestData.activity_date_from}
                    valueDate={disputeRequestData.activity_date_from}
                    onChange={handleChangeActivityDateFrom}
                  />
                </div>
                <div className="col-lg-4 col-sm-6">
                  <DatePickerFormated
                    mb4="mb-4"
                    labelHtmlFor="activity_date_to"
                    name="activity_date_to"
                    name_datepicker="activity_date_to"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="تاريخ إقامة النشاط إلى"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputType="datePicker"
                    inputId="activity_date_to_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    pText={error_new_user.activity_date_to}
                    minDate={moment(
                      disputeRequestData.activity_date_from,
                    ).toDate()}
                    maxDate={moment()}
                    value={disputeRequestData.activity_date_to}
                    valueDate={disputeRequestData.activity_date_to}
                    onChange={handleChange}
                  />
                </div>
              </>
            ))}
          <div className="col-md-12">
            <TextAreaElement
              mb4="mb-4"
              labelHtmlFor="dispute_subject"
              labelClassName={`required form-label ${stylesRequestData["form-label"]}`}
              labelText="موضوع المنازعة"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputType="text"
              teaxtAreaID="dispute_subject"
              teaxtAreaClassName="form-control"
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              inputId="dispute_subject_input"
              pText={error_new_user.dispute_subject}
              value={disputeRequestData.dispute_subject || ""}
              onChange={handleChange}
              name="dispute_subject"
              disabled={false}
              allowedPattern={
                // /^(?!.*\.\d)(?!.*؟)[a-zA-Z\u0600-\u06FF0-9\s\-,.\/\\]*$/
                /^(?!.*\.\d)(?!.*[؛،؟])[a-zA-Z0-9\s\-,.\/\\\u0621-\u064A\u066E-\u067F\u0681-\u06D5]*$/
              }
              maxLength={500}
            />
          </div>
        </div>
      </div>
      <div className="box pdf-box">
        <div className="row">
          {disputeRequestData.tax_type &&
            (parseInt(disputeRequestData.tax_type) === 1 ? (
              <>
                <div className="col-md-4">
                  <InputElementDispute
                    value={disputeRequestData.disputed_annual_base_value || ""}
                    disabled={false}
                    name="disputed_annual_base_value"
                    mb4="mb-4"
                    labelHtmlFor="disputed_annual_base_value"
                    labelClassName={`required  ${stylesRequestData["form-label"]} form-label`}
                    labelText="قيمة الوعاء السنوي المتنازع عليه  "
                    inputType="text"
                    onChange={handleChange}
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="disputed_annual_base_value_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    allowedPattern={/^\d{1,13}(\.\d{0,2})?$/}
                    pText={error_new_user.disputed_annual_base_value}
                  />
                </div>
                <div className="col-md-4">
                  <InputElementDispute
                    value={disputeRequestData.disputed_annual_tax_value || ""}
                    disabled={false}
                    name="disputed_annual_tax_value"
                    mb4="mb-4"
                    labelHtmlFor="disputed_annual_tax_value"
                    labelClassName={`required  ${stylesRequestData["form-label"]} form-label`}
                    labelText="قيمة الضريبة السنوية المتنازع عليها "
                    inputType="text"
                    onChange={handleChange}
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="disputed_annual_tax_value_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    allowedPattern={/^\d{1,13}(\.\d{0,2})?$/}
                    pText={error_new_user.disputed_annual_tax_value}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="col-md-4">
                  <InputElementDispute
                    value={disputeRequestData.disputed_tax_value || ""}
                    disabled={false}
                    name="disputed_tax_value"
                    mb4="mb-4"
                    labelHtmlFor="disputed_tax_value"
                    labelClassName={`required  ${stylesRequestData["form-label"]} form-label`}
                    labelText="قيمة الضريبة المتنازع عليها"
                    inputType="text"
                    onChange={handleChange}
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="disputed_tax_value_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    allowedPattern={/^\d{1,13}(\.\d{0,2})?$/}
                    pText={error_new_user.disputed_tax_value}
                  />
                </div>
                <div className="col-md-4">
                  <InputElementDispute
                    value={disputeRequestData.disputed_increase_value || ""}
                    disabled={false}
                    name="disputed_increase_value"
                    mb4="mb-4"
                    labelHtmlFor="disputed_increase_value"
                    labelClassName={`required  ${stylesRequestData["form-label"]} form-label`}
                    labelText="قيمة الزيادة (الغرامة) المتنازع عليها"
                    inputType="text"
                    onChange={handleChange}
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="disputed_increase_value_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    allowedPattern={/^\d{1,13}(\.\d{0,2})?$/}
                    pText={error_new_user.disputed_increase_value}
                  />
                </div>
              </>
            ))}
          <div className="col-lg-4 col-sm-6">
            <SearchSelectElement
              mb4="mb-4"
              disabled={parseInt(disputeRequestData.tax_type) === 2}
              labelHtmlFor="dispute_reviewer"
              labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
              labelText="الجهة المنظور أمامها النزاع حاليا"
              selectClassName={`${stylesRequestData["form-select"]} form-select`}
              selectID="dispute_reviewer"
              inputId="dispute_reviewer_input"
              name="dispute_reviewer"
              options={generateOptions(disputeReviewrs)}
              default={"الجهه المنظور أمامها النزاع حاليا .."}
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              pText={error_new_user.dispute_reviewer}
              value={disputeRequestData.dispute_reviewer}
              // value={disputeRequestData.tax_type == 2 ? 1 : disputeRequestData.dispute_reviewer}
              onChange={handleChangeDisputeReviewer}
              isClearable={true}
            />
          </div>
          {parseInt(disputeRequestData.dispute_reviewer) === 1 ? (
            <>
              <div className="col-lg-4 col-sm-6">
                <InputElementDispute
                  value={disputeRequestData.court || ""}
                  disabled={false}
                  name="court"
                  mb4="mb-4"
                  labelHtmlFor="court"
                  labelClassName={`required  ${stylesRequestData["form-label"]} form-label`}
                  labelText="محكمة"
                  inputType="text"
                  onChange={handleChange}
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="court_input"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  maxLength={64}
                  allowedPattern={
                    // /^(?!.*-\d)(?!.*\d\.\d)(?!.*\.\d)(?!.*\d\.)(?!.*؟)[\u0600-\u06FF\s\-,.\\\/0-9]*$/
                    // /^(?!.*\d\.\d)(?!.*\.\d)(?!.*\d\.)(?!.*؟)[\u0600-\u06FF\s\-,.\\\/0-9]*$/
                    /^(?!.*\d\.\d)(?!.*\.\d)(?!.*\d\.)(?!.*[؟؛،])[\u0600-\u06FF\s\-,.\\\/0-9]*$/
                  }
                  pText={error_new_user.court}
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <InputElementDispute
                  value={disputeRequestData.lawsuit_number || ""}
                  disabled={false}
                  name="lawsuit_number"
                  mb4="mb-4"
                  labelHtmlFor="lawsuit_number"
                  labelClassName={`required  ${stylesRequestData["form-label"]} form-label`}
                  labelText="رقم الدعوى"
                  inputType="text"
                  onChange={handleChange}
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="lawsuit_number_input"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  maxLength={64}
                  allowedPattern={
                    // /^(?!.*-\d)(?!.*\d\.\d)(?!.*\.\d)(?!.*\d\.)(?!.*؟)[\u0600-\u06FF\s\-,.\\\/0-9]*$/
                    /^(?!.*-\d)(?!.*\d\.\d)(?!.*\.\d)(?!.*\d\.)(?!.*[؟؛،])[\u0600-\u06FF\s\\\/0-9]*$/
                  }
                  pText={error_new_user.lawsuit_number}
                />
              </div>
              <div className="col-lg-4 col-sm-6">
                <DatePickerFormated
                  name="filing_lawsuit_date"
                  name_datepicker="filing_lawsuit_date"
                  mb4="mb-4"
                  labelHtmlFor="filing_lawsuit_date"
                  labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                  labelText="تاريخ إيداع الدعوى"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputType="datePicker"
                  inputId="filing_lawsuit_date_input"
                  maxDate={moment()}
                  minDate={moment("1990-01-01").toDate()}
                  // min={moment('1990-01-01', 'YYYY-MM-DD')}
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  pText={error_new_user.filing_lawsuit_date}
                  minYear="1990"
                  value={disputeRequestData.filing_lawsuit_date}
                  valueDate={disputeRequestData.filing_lawsuit_date}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <InputElementDispute
                  mb4="mb-4"
                  inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                  labelHtmlFor="court_case_registration_certificate"
                  labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                  labelText="صورة شهادة قيد الدعوى من المحكمة"
                  inputType="file"
                  inputClassName={`${stylesRequestData["form-control"]} form-control`}
                  inputID="court_case_registration_certificate"
                  key={`court-${fileInputKeys.court}`}
                  name="court_case_registration_certificate"
                  fileName={fileName}
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  icon="fa-solid fa-cloud-arrow-up"
                  accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                  pText={error_new_user.court_case_registration_certificate}
                  onChange={handleChange}
                />
              </div>
            </>
          ) : (
            disputeRequestData.dispute_reviewer && (
              <>
                <div className="col-lg-4 col-sm-6">
                  <InputElementDispute
                    value={disputeRequestData.appeal_committee || ""}
                    disabled={false}
                    name="appeal_committee"
                    mb4="mb-4"
                    labelHtmlFor="appeal_committee"
                    labelClassName={`required  ${stylesRequestData["form-label"]} form-label`}
                    labelText="لجنة الطعن"
                    inputType="text"
                    onChange={handleChange}
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="appeal_committee_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    maxLength={64}
                    allowedPattern={
                      // /^(?!.*\d\.\d)(?!.*\.\d)(?!.*\d\.)(?!.*؟)[\u0600-\u06FF\s\-,.\\\/0-9]*$/
                      /^(?!.*\d\.\d)(?!.*\.\d)(?!.*\d\.)(?!.*[؟؛،])[\u0600-\u06FF\s\-,.\\\/0-9]*$/
                    }
                    pText={error_new_user.appeal_committee}
                  />
                </div>
                <div className="col-lg-4 col-sm-6">
                  <InputElementDispute
                    value={disputeRequestData.appeal_number || ""}
                    disabled={false}
                    name="appeal_number"
                    mb4="mb-4"
                    labelHtmlFor="appeal_number"
                    labelClassName={`required  ${stylesRequestData["form-label"]} form-label`}
                    labelText="رقم الطعن"
                    inputType="text"
                    onChange={handleChange}
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="appeal_number_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    maxLength={64}
                    allowedPattern={
                      /^(?!.*-\d)(?!.*\d\.\d)(?!.*\.\d)(?!.*\d\.)(?!.*[؟؛،])[\u0600-\u06FF\s\\\/0-9]*$/
                    }
                    pText={error_new_user.appeal_number}
                  />
                </div>
                <div className="col-lg-4 col-sm-6">
                  <DatePickerFormated
                    name="appeal_date"
                    name_datepicker="appeal_date"
                    mb4="mb-4"
                    labelHtmlFor="appeal_date"
                    labelClassName={` required form-label ${stylesRequestData["form-label"]}`}
                    labelText="تاريخ الطعن"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputType="datePicker"
                    inputId="appeal_date_input"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    pText={error_new_user.appeal_date}
                    minYear="2013"
                    minDate={moment("2013-01-01").toDate()}
                    maxDate={moment()}
                    value={disputeRequestData.appeal_date}
                    valueDate={disputeRequestData.appeal_date}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <InputElementDispute
                    mb4="mb-4"
                    inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                    labelHtmlFor="appeal_insurance_voucher"
                    labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                    labelText="صورة قسيمة سداد تأمين الطعن"
                    inputType="file"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="appeal_insurance_voucher"
                    key={`appeal-${fileInputKeys.appeal}`}
                    name="appeal_insurance_voucher"
                    fileName="إرفاق ملف"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    icon="fa-solid fa-cloud-arrow-up"
                    accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                    pText={error_new_user.appeal_insurance_voucher}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <InputElementDispute
                    mb4="mb-4"
                    inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                    labelHtmlFor="tax_notification_form"
                    labelClassName={` required ${stylesRequestData["form-label"]} form-label`}
                    labelText="صورة الإخطار بالضريبة نموذج رقم 3 أو المطالبة"
                    inputType="file"
                    inputClassName={`${stylesRequestData["form-control"]} form-control`}
                    inputID="tax_notification_form"
                    key={`tax-${fileInputKeys.tax}`}
                    name="tax_notification_form"
                    fileName="إرفاق ملف"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    icon="fa-solid fa-cloud-arrow-up"
                    accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                    pText={error_new_user.tax_notification_form}
                    onChange={handleChange}
                  />
                </div>
              </>
            )
          )}
        </div>
        <div className="row pt-5">
          <div className="list-group border-0">
            <label
              htmlFor="date"
              className={`required ${stylesRequestData["list-group-item"]} list-group-item border-0`}
            >
              <input
                type="checkbox"
                className={`${stylesRequestData["form-check-input"]} form-check-input ms-3`}
                name="acknowledge_email"
                id="acknowledge_email"
                checked={disputeRequestData.acknowledge_email}
                onChange={(e) =>
                  handleChange(
                    "",
                    "",
                    "acknowledge_email",
                    e.target.checked ? 1 : 0,
                  )
                }
              />
              <span style={{ fontSize: "15px" }}>
                {"أقر  بأن البريد الإلكتروني المستخدم هو عنوان المراسلة "}
              </span>
            </label>
            {isCheckedEmail && !disputeRequestData.acknowledge_email && (
              <p
                className="text-danger mb-0 mt-2 me-2 fw-bolder"
                id="acknowledge_email_error"
              >
                {"يجب أن تقر بأن البريد الإلكتروني المستخدم هو عنوان المراسلة"}
              </p>
            )}
          </div>
          <div className="list-group border-0">
            <label
              htmlFor="date"
              className={`required ${stylesRequestData["list-group-item"]} list-group-item border-0`}
            >
              <input
                type="checkbox"
                className={`${stylesRequestData["form-check-input"]} form-check-input ms-3`}
                name="acknowledge_accuracy_register_data_with_doc_first_session"
                id="acknowledge_accuracy_register_data_with_doc_first_session"
                checked={
                  disputeRequestData.acknowledge_accuracy_register_data_with_doc_first_session
                }
                onChange={(e) =>
                  handleChange(
                    "",
                    "",
                    "acknowledge_accuracy_register_data_with_doc_first_session",
                    e.target.checked ? 1 : 0,
                  )
                }
              />
              <span style={{ fontSize: "15px" }}>
                {
                  "أقر بصحة البيانات المقدمة مع تقديم المستندات المطلوبة فى تاريخ أول جلسة "
                }
              </span>
            </label>
            {isCheckedAccuracyFirstSession &&
              !disputeRequestData.acknowledge_accuracy_register_data_with_doc_first_session && (
                <p
                  className="text-danger mb-0 mt-2 me-2 fw-bolder"
                  id="acknowledge_accuracy_register_data_with_doc_first_session_error"
                >
                  {
                    "يجب أن تقر بصحة البيانات المقدمة مع تقديم المستندات المطلوبة فى تاريخ أول جلسة"
                  }
                </p>
              )}
          </div>
        </div>
        <div className="d-flex flex-lg-row flex-column justify-content-start  gap-3  align-items-center pb-5 mt-4 pt-5">
          {/* {console.log(isValid)} */}
          <button
            type="button"
            disabled={isLoading || !isValid}
            className={` ${stylesRequestData["btn-request"]} ${
              isLoading || !isValid ? stylesRequestData["disabled"] : ""
            }`}
            onClick={handleSubmit}
            id="submit_request_data"
          >
            تقديم الطلب
          </button>
          <button
            onClick={() => {
              navigate("/tax-dispute-request/list-data", {
                state: { message: "تم إلغاء تقديم الطلب" },
              });
            }}
            className={` ${stylesRequestData["btn-login"]} `}
            id="cancel_request_data"
          >
            إلغاء
          </button>
        </div>
      </div>
    </>
  );
};

export default DisputeRequestData;
